import { ConditionalPartial } from '../../../../utils';

import { CreateMandatoryProblemReportingConfigRequestDto } from './create-mandatory-problem-reporting-config.request.dto';

/**
 * DTO for updating mandatory problem reporting configuration
 * All fields are optional for partial updates
 */
export class UpdateMandatoryProblemReportingConfigRequestDto extends ConditionalPartial(
    CreateMandatoryProblemReportingConfigRequestDto,
) {}
